/*
 * @Description: 路由
 * @Author: lmj limengjuan@36kr.com
 * @Date: 2023-08-18 19:09:02
 * @LastEditors: lmj limengjuan@36kr.com
 * @LastEditTime: 2023-08-31 19:30:31
 */
import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/polymerize/strongPushNew',
  owner: '/home',
  authority: 'recommendInfoFlow',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};